<template>
  <div style="width:90%">
		<div class="container_body">
      <header class="header_nav">
        <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
          <el-form-item label="买方用户ID" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.userId" placeholder="请输入买方用户ID"></el-input>
					</el-form-item>
          <el-form-item label="买方用户名" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.username" placeholder="请输入买方用户名"></el-input>
					</el-form-item>
          <el-form-item label="卖方用户ID" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.saleUserId" placeholder="请输入卖方用户ID"></el-input>
					</el-form-item>
          <el-form-item label="卖方用户名" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.saleUsername" placeholder="请输入卖方用户名"></el-input>
					</el-form-item>
          <el-form-item label="订单状态" class='tiny' cleartable>
            <el-select v-model="searchInfo.otcStatus" placeholder="请选择" clear>
							<el-option key="waiting" label="等待付款" value="waiting">等待付款</el-option>
							<el-option key="success" label="交易成功" value="success">交易成功</el-option>
							<el-option key="cancel" label="交易取消" value="cancel">交易取消</el-option>
						</el-select>
					</el-form-item>
            <el-form-item label="时间" class='tiny' cleartable>
              <el-date-picker
                v-model="dateArr"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
          <el-form-item>
            <template>
              <el-button type="primary" @click="searchRecordsData">查询</el-button>
							<el-button  @click="empty">清空</el-button>
              <el-button type="primary" @click="downloadFile"> 导出 </el-button>
            </template>
          </el-form-item>
        </el-form>
      </header>
    </div>
        <el-table :data="recordsData"  style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" 
        element-loading-spinner="el-icon-loading" :header-cell-style="headClass">
              <el-table-column property="userId"  label="买方用户ID" align="center" width="100"></el-table-column>
              <el-table-column property="username"  label="买方用户名" align="center" width="150"></el-table-column>
              <el-table-column property="saleUserId"  label="卖方用户ID" align="center" width="100"></el-table-column>
              <el-table-column property="saleUsername"  label="卖方用户名" align="center" width="150"></el-table-column>
              <el-table-column property="integralName"  label="挂卖资产" align="center" width="80"></el-table-column>
              <el-table-column property="otcSaleId"  label="挂卖订单ID" align="center" width="120"></el-table-column>
              <el-table-column property="otcBuyNumber" label="购买数量" align="center" width="80">
                <template slot-scope="scope">
                  <span>{{Math.floor(scope.row.otcBuyNumber)}}</span>
                </template>
              </el-table-column>
              <el-table-column property="payMoney" label="积分总价(￥)" align="center" width="120"></el-table-column>
              <el-table-column property="certificate" label="付款凭证" align="center" width="150">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image 
                      fit="scale-down"
                      style="width: 100px; height: 100px"
                      :src="scope.row.certificate" 
                      :preview-src-list="[scope.row.certificate]">
                    </el-image>
                  </div>
                  
                </template>
              </el-table-column>
              <el-table-column property="userCertificateId"  label="付款人" align="center" width="150">
                <template slot-scope="scope">
                  <span> {{ scope.row.userCertificateId }} ~ {{ scope.row.certificateUsername }}</span>
                </template>
              </el-table-column>
              <el-table-column property="otcStatus" label="订单状态" align="center" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.otcStatus === 'waiting'">等待付款</span>
                  <span v-if="scope.row.otcStatus === 'success'">交易成功</span>
                  <span v-if="scope.row.otcStatus === 'cancel'">交易取消</span>
                </template>
              </el-table-column>
              <el-table-column property="createDate" label="创建时间" width="160" align="center"></el-table-column>
              <el-table-column property="buyMemo" label="备注信息" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.buyMemo == null ? '暂无' : scope.row.buyMemo }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="操作"  fixed="right"  width="100" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.otcStatus === 'waiting'">
                    <el-button type="text" size="small" @click="uploadProof(scope.row.otcSaleId,scope.row.id)">上传凭证</el-button>
                  </div>
                  <div v-if="scope.row.otcStatus === 'waiting'">
                    <el-button type="text" size="small" @click="open(scope.row.id)">取消交易</el-button>
                  </div>
                  <div v-else>
                    <el-button type="text" size="small">暂无操作</el-button>
                  </div>
                </template>
              </el-table-column>
        </el-table>
        <el-pagination  background :current-page="page.pageNum"
            @current-change="pageChangeRecords" layout="total, sizes, prev, pager, next, jumper" :total="recordsTotal"
            @size-change="handleSizeChangeRecords" :page-sizes="[10, 20, 50, 100]">
        </el-pagination>
        <el-dialog
        width="30%"
        title="付款"
        :visible.sync="dialogVisible">
        <div>
          <el-form :inline="true" class="demo-form-inline" :model="accountInfo" style="margin: 20px 0px 0px 20px;">
                  <div style="height:50px">
                    <el-form-item label="收款账号类别:">
                      <el-select v-model="accountInfo.cardType" placeholder="请选择" disabled>
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div v-if="accountInfo.cardType == 1">
                    <div style="height:50px">
                      <el-form-item label="持卡人姓名:">
                        <span>{{ accountInfo.cardUserName }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="银行卡号:">
                        <span>{{ accountInfo.cardNo }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="开户银行:">
                        <span>{{ accountInfo.cardBank }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="开户银行支行:">
                        <span>{{ accountInfo.cardSubbranch }}</span>
                      </el-form-item>
                    </div>
                  </div>
                  <div v-if="accountInfo.cardType == 2 || accountInfo.cardType == 3 " style="height:50px">
                    <el-form-item label="账户姓名">
                      <el-input v-model="accountInfo.cardUserName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="账号">
                      <el-input v-model="accountInfo.cardNo" disabled></el-input>
                    </el-form-item>
                  </div>
                  <div v-if="accountInfo.cardType == 2 || accountInfo.cardType == 3 " style="height:50px">
                    <el-form-item label="收款二维码图片">
                      <el-image 
                        style="width: 150px; height: 150px"
                        :src="accountInfo.cardImg" 
                        fit="scale-down"
                        :preview-src-list="[accountInfo.cardImg]">
                      </el-image>
                    </el-form-item>
                  </div>
                  <div style="height:120px">
                    <el-form-item label="上传凭证:">
                      <el-upload class="avatar-uploader" :action="httpUrl"
                        :before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
                        <img style="width: 100px;height: 100px;" v-if="imgUrl" :src="imgUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </div>
                  <div style="height:50px">
                    <el-form-item label="备注:">
                      <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        style="width: 250px;"
                        v-model="uploadInfo.buyMemo">
                      </el-input>
                    </el-form-item>
                  </div>
          </el-form>
        </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureUploadProof">确 认</el-button>
          </div>
        </el-dialog>
    </div>
    
</template>
<script>
import {
		uploadFileServer
} from "@/api/axios.js";
var urls = uploadFileServer('buyrecord');
export default {
  data() {
    return {
      searchInfo: {},
      recordsData: [],
      recordsID: '',
      recordsTotal: 0,
      searchRecordsInfo:{},
      page: {
					pageNum: 1,
					pageSize: 10
			},
      loading: false,
      dialogVisible: false,
      id: '',
      otcSaleId:'',
      imgUrl: '',
      accountInfo: {},
      httpUrl: urls,
      uploadInfo: {},
      options: [{
          value: 1,
          label: '银行卡'
        }, {
          value: 2,
          label: '支付宝'
        }, {
          value: 3,
          label: '微信'
      }],
      value: '',
      dateArr: [],
      
    }
  },
  methods: {
    pageChangeRecords(val) {
      this.page.pageNum = val
      this.getRecordsList()
    },
    handleSizeChangeRecords(val) {
      this.page.pageSize = val
      this.getRecordsList()
    },
    getRecordsList() {
      this.loading = true
      let obj = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }
      let data = Object.assign(this.searchInfo,obj)
      this.$api.getOtcBuyList(data).then(res => {
        console.log(res.data)
        if(res.state == 'success'){
          this.loading = false
          this.recordsData = res.data.list
          this.recordsTotal = res.data.total
          console.log('表格数据---',this.recordsData)
        }
      })
    },
    headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
		},
    downloadFile() {
      console.log(this.searchInfo);
      // let data = {
      //     otcStatus: this.searchInfo.otcStatus ? this.searchInfo.otcStatus : "",
			// 		userId: this.searchInfo.userId ? this.searchInfo.userId : "",
			// 		username: this.searchInfo.username ? this.searchInfo.username : "",
			// 	};
			// console.log(data);
				this.$api.exportExcelOtcBuy(this.searchInfo).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
    },
    showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "会员买单记录" + ".xls");
				document.body.appendChild(link);
				link.click();
				// URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
    searchRecordsData() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      // let obj = {
      //   pageNum: this.page.pageNum,
      //   pageSize: this.page.pageSize
      // }
      // let data = Object.assign(this.searchInfo,obj)
      // this.$api.getOtcBuyList(data).then(res => {
      //   if(res.state == 'success'){
      //     this.recordsData = res.data.list
      //     this.recordsTotal = res.data.total
      //   }
      // })
      this.getRecordsList();
    },
     searchRecordsData() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      if(this.dateArr.length>0){
          this.dateArr.forEach((item,index) => {
          this.dateArr.splice(index,1,this.$moment(item).format('YYYY-MM-DD HH:mm:ss'))
        })
        this.searchInfo.startTime = this.dateArr[0]
        this.searchInfo.endTime = this.dateArr[1]
      }
      this.getRecordsList();
    },
    empty() {
      this.searchInfo = {}
      this.dateArr = []
    },
    uploadProof(id,TID) {
      this.dialogVisible = true
      this.id = TID
      this.otcSaleId = id
      this.imgUrl = ''
      this.accountInfo = {}
      this.$api.getotcSale(id).then(res => {
        this.accountInfo = res.data
      })
    },
    // 上传图片前，筛选
		beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
      //上传凭证
			onSuccess(response, file, fileList) {
				this.imgUrl = response.message;
			},
      sureUploadProof() {
        let data = {
          id: this.id,
          certificate:  this.imgUrl
        }
        this.$api.editOtcBuy(data).then(res => {
          if(res.state) {
            this.dialogVisible = false
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getRecordsList()
          }else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      },
      open(id) {
        this.$confirm('此操作将取消交易, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
          this.$api.cancelOtcBuy(id).then(res => {
            console.log(res)
            if(res.state == 'success'){
               this.$message({
                type: 'success',
                message: res.message
              });
              this.getMinBuyList()
            }else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      }
  },
  created() {
    this.getRecordsList()
  }
}
</script>
<style lang="less">
.el-icon-circle-close {
  color: #fff;
}
.el-image-viewer__close {
  top: 10px;
  right: 450px;
}
</style>